import axios from "axios";
import { handleAjaxError } from "../utils/PlatformAPIUtils";
import { log as logger } from "../utils/Logging";
import ClientContext from "../utils/client-context/ClientContext";

/**
 * Fetch a config object from the platform. Public ones only.
 *
 * @param {string} configName
 * @param {function} callback
 */
export const fetchPlatformConfig = (configName, callback) => {
  const log = logger.getLogger("ConfigAPI fetchConfig");
  const configURL = `${process.env.REACT_APP_BASE_PLATFORM_URL}community/config?name=${configName}`;
  axios.get(configURL, {
    headers: {
      "x-api-key": ClientContext._apiKey || process.env.DATA_CLIENT_KEY
    }
  }).then(response => {
    log.info(`${configName} successfully retrieved`);
    callback(response.data);
  }).catch(err => {
    handleAjaxError(err, "ConfigAPI fetchConfig");
    callback();
  });
};

/**
 * The ability to load multiple config items in paralell
 *
 * @param {array} configItems
 * @param {function} callback
 */
export const fetchMultipleConfigItems = (configItems, restrictedHeaders, callback) => {
  const log = logger.getLogger("ConfigAPI fetchMultipleConfigItems");
  const apiCalls = [];
  configItems.map(configItem => {
    const path = restrictedHeaders ? `${process.env.REACT_APP_STAGE}/` : "community/";
    const configURL = `${process.env.REACT_APP_BASE_PLATFORM_URL}${path}config?name=${configItem.name}`;
    apiCalls.push(axios.get(configURL, {
      headers: restrictedHeaders ? restrictedHeaders : {
        "x-api-key": ClientContext._apiKey || process.env.DATA_CLIENT_KEY
      }
    }));
  });
  Promise.allSettled(apiCalls).then(axios.spread((...responses) => {
    log.debug(responses);
    const platformConfigResponses = {};
    responses.map(response => {
      if (response.status !== "rejected") {
        const item = configItems.find(configItem => {
          return response.value.config.url.includes(configItem.name);
        });
        const configData = response.value.data;
        platformConfigResponses[item.stateKey] = item.dataProcessor ? item.dataProcessor(configData) : configData;
      }
    });
    log.debug(platformConfigResponses);
    callback(platformConfigResponses);
  })).catch(error => {
    handleAjaxError(error, "ConfigAPI fetchMultipleConfigItems");
    callback();
  });
};